module.exports = __webpack_public_path__ + "img/logo.22cf9086.png";